// extracted by mini-css-extract-plugin
module.exports = {"cell-address":"PropertiesTableContainer_cell-address__lACdu","cell-name":"PropertiesTableContainer_cell-name__ZtXDm","link":"PropertiesTableContainer_link__2kP0K"};